import { Delete } from "@material-ui/icons";
import { useState } from "react";
import { Button, ImageField, ImageInput, useRecordContext } from "react-admin";
import { useForm } from "react-final-form";
import { OnChange } from "react-final-form-listeners";

/*
    props : 
    source = "zoneimage_app_tc" 
    sourceBase = "zoneimage_app_tc_base64" 
    label = "ZoneImage"
*/
export const ImageDropzone = (props) => {
  const [show, setShow] = useState(true);

  const form = useForm();

  const record = useRecordContext();

  return (
    <>
      <h3>{props.label}</h3>

      {show ? (
        <ImageField source={props.source} />
      ) : record[props.source] ? (
        <>
          <span style={{ color: "red", fontStyle: "italic" }}>Existing Image will be removed</span>
        </>
      ) : (
        <></>
      )}

      <ImageInput source={props.sourceBase} label="" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>

      <Button
        startIcon={<Delete />}
        label="Remove"
        onClick={() => {
          form.change(props.sourceBase, "remove");
          setShow(false);
        }}
      />

      <OnChange name={props.sourceBase}>
        {() => {
          setShow(false);
        }}
      </OnChange>
    </>
  );
};
